<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">银行卡管理</div>
    </div>
    <div class="wrap_box warp1">
      <p>
        <span>{{ allNum }}</span> 个绑定的银行卡
      </p>
    </div>
    <div class="wrap_box warp2">
      <div v-for="i in data.list" class="item">
        <img
          :src="require('../images/user/recharge' + 4 + '.png')"
          alt=""
        />
        <div class="item_detail">
          <p class="user_name ari_font">
            {{ i.bank }}
          </p>
          <p class="user_num">
            {{ i.account }}
          </p>
        </div>
        <div class="del" @click="delCard(i.id)" />
      </div>
    </div>
    <div class="basic_btn" @click="$router.push('/addbank')">新增银行卡</div>
  </div>
</template>

<script>
  import Fetch from '../../utils/fetch'

  export default {
    name: 'Account',
    data() {
      return {
        allNum: 0,
        data: {},
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
    mounted() {
      document.getElementById('app').style.background =
        'linear-gradient(to bottom, #5674d3, #a8b6e5)'
      document.getElementById('app').style.marginBottom = '0px'
      this.start()
    },
    methods: {
      delCard(id) {
        Fetch('/user/bank_remove', { id: id }).then(() => {
          this.start()
        })
      },
      start() {
        Fetch('/user/bank').then((r) => {
          // 过滤数据，只保留银行卡类型
          const bankList = r.data.list.filter(item => {
            // 根据实际情况调整判断条件
            return !item.bank?.includes('USDT') && 
                   !item.account?.includes('USDT') &&
                   item.type !== 'USDT'; // 如果有type字段的话
          });
          
          this.data = {
            ...r.data,
            list: bankList
          }
          this.allNum = bankList.length; // 更新数量为过滤后的数量
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
  // .back_left {
  //   background: url(../../views/images/item/back_b.png) no-repeat center center;
  // }
  .big_tit {
    color: #fff;
  }

  .warp1 {
    padding: 20px;
    height: 40px;
    background: none;
    p {
      font-size: 14px;
      line-height: 40px;
      color: rgba(0, 0, 0, 0.8);
      font-weight: bold;
      background: #fff;
      border-radius: 10px;
      padding: 4px;
      span {
        color: #4a75f3;
      }
    }
  }

  .ari_font {
    height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }

  .warp2 {
    padding: 0 15px;
    margin-top: 12px;

    .item {
      padding: 14px 0 11px 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid #ececec;

      &:last-child {
        border-bottom: none;
      }

      img {
        width: 30px;
        height: 30px;
      }

      .item_name {
        width: 65px;
      }
      .item_detail {
        margin-left: 10px;
      }

      .user_num {
        height: 17px;
        font-size: 12px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.6);
        line-height: 17px;
        margin-top: 10px;
      }

      .del {
        width: 20px;
        height: 20px;
        background: url(../images/item/del.png) no-repeat center center;
        background-size: 100% 100%;
        margin: 0 8px 0 auto;
      }
    }
  }

  .basic_btn {
    margin: 43px auto 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(to left, #756ff3, #399ffe);
    border-radius: 10px;
    color: #ffffff !important;
    text-align: center;
    margin-top: 40px !important;
  }
</style>
